export class DoctorNationality {
  nationalityName: string;
  status: string;
  id: number;
}
